import React, { useState, useEffect } from 'react'
import './assets/css/style.css';
import './assets/css/responsive.css';
import {
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { useAuth } from './hooks/useAuth';

import MiniHeader from './Components/MiniHeader';
import Home from './Pages/Home';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Pledge from './Pages/Pledge';
import Team from './Pages/Team';
import SevenMission from './Pages/SevenMission';
import Rewards from './Pages/Rewards';
import Contact from './Pages/Contact';
import Events from './Pages/Programmes/Events';
import Coin from './Pages/Programmes/Cities.js';
import Gifts from './Pages/Programmes/Gifts';
import GiftsLogin from './Pages/Programmes/GiftsLogin';
import Courses from './Pages/Programmes/Courses.js';
import Influencers from './Pages/Programmes/Influencers.js';
import Cafee from './Pages/Programmes/Cafee.js';
import ArtPublication from './Pages/Programmes/ArtPublications.js';
import ScrollToTopButton from './Components/ScrollToTopButton.js';
import ScrollToTop from './Components/ScrollToTop.js';

import Login from './Pages/Login.js';
import Otp from './Pages/Otp.js';
import Register from './Pages/Register.js'
import Dashboard from './Pages/Dashboard/IAMDashboard.js';
import ActivateAccount from './Pages/ActivateAccount.js';
import SetupPassword from './Pages/SetUpPassword.js';
import ForgotPassword from './Pages/ForgotPassword.js';
import UserProfile from './Components/UserProfile.js';
import ProtectedRoute from './Components/ProtectedRoute.js';
import NavigationGuard from './Components/NavigationGuard.js';
import AdminRouteGuard from './Components/AdminRouteGuard.js';
import Networks from './Pages/Programmes/Networks.js';
import Cities from './Pages/Programmes/Cities.js';
import SchoolCampuses from './Pages/Programmes/SchoolCampuses.js';
import OrganisationsCorporate from './Pages/Programmes/OrganisationsCorporate.js';
import WelfareFund from './Pages/Programmes/WelfareFund.js';
import PrivacyPolicy from './Pages/PrivacyPolicy.js';
import Voices from './Pages/Programmes/Voices.js';
import AdminLogin from './Pages/AdminLogin.js';
import AdminDashboard from './Pages/AdminDashboard';
import PaymentsPage from './Pages/PaymentsPage.jsx';

function App() {
  // Initialize authentication
  useAuth();

  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const isOtpPage = location.pathname === '/otp';
  const isRegisterPage = location.pathname === '/register';
  const isDashboardPage = location.pathname === '/dashboard';
  const isActivateAccountPage = location.pathname === '/activateaccount';
  const isSetPasswordPage = location.pathname === '/setuppassword';
  const isForgotPasswordPage = location.pathname === '/forgotpassword';
  const isPrivacyPolicyPage = location.pathname === '/privacypolicy';
  const isAdminLoginPage = location.pathname === '/adminlogin';
  const isAdminDashboardPage = location.pathname.startsWith('/admin/');
  const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const isMobileView = window.innerWidth < 800;
  const isCordova = !!window?.cordova;
  const isRootPage = location.pathname === '/';
  const shouldShowMiniHeader =
    !isLoginPage &&
    !isOtpPage &&
    !isRegisterPage &&
    !isDashboardPage &&
    !isActivateAccountPage &&
    !isSetPasswordPage &&
    !isForgotPasswordPage &&
    !isPrivacyPolicyPage &&
    !isAdminLoginPage &&
    !isAdminDashboardPage &&
    !(isRootPage && (isCordova));
  //!(isRootPage && (isCordova || isMobileView));

  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      // Try to open the app
      //window.location.href = "myapp://activateaccount";

      // Fallback to store after 1 second if app not installed
      // setTimeout(() => {
      //   if (/Android/i.test(navigator.userAgent)) {
      //     window.location.href = "https://play.google.com/store/apps/details?id=com.myapp";
      //   } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      //     window.location.href = "https://apps.apple.com/app/id123456789";
      //   }
      // }, 1000);
    }
  }, []);

  return (
    <NavigationGuard>
      <div className="App">
        {shouldShowMiniHeader && <MiniHeader />}
        {shouldShowMiniHeader && <Header />}

        <ScrollToTopButton />
        <ScrollToTop />
        <Routes>
          {/* <Route path="/" element={<MainWrapper />} /> */}

          {(window?.cordova) ?    //|| window.document.body.clientWidth < 800
            <Route path="/" element={<Login />} />
            :
            <Route path="/" element={<Home />} />
          }

          <Route path="/login" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/otp" element={<Otp />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/activateaccount" element={<ActivateAccount />} />
          <Route path="/setuppassword" element={<SetupPassword />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          } />
          
          {/* Admin Routes */}
          <Route path="/adminlogin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <AdminRouteGuard>
              <AdminDashboard />
            </AdminRouteGuard>
          } />
          
          {/* Entity Dashboard Routes */}
          
          <Route path="/pledge" element={<Pledge />} />
          <Route path="/team" element={<Team />} />
          <Route path="/7missions" element={<SevenMission />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Schools-Colleges-Universities" element={<SchoolCampuses />} />
          <Route path="/Organisations-Corporates" element={<OrganisationsCorporate />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/Cities" element={<Cities />} />
          <Route path="/Networks-International-Directors" element={<Networks />} />
          <Route path="/Gifts" element={<Gifts />} />
          <Route path="/Gifts/Login" element={<GiftsLogin />} />
          <Route path="/Institute" element={<Courses />} />
          <Route path="/Influencers" element={<Influencers />} />
          <Route path="/Welfare-Fund" element={<WelfareFund />} />
          <Route path="/Cafee" element={<Cafee />} />
          <Route path="/Voices" element={<Voices/>} />
          <Route path="/Arts-and-Publications" element={<ArtPublication />} />
          <Route path="/payments" element={<PaymentsPage />} />

        </Routes>

        {(shouldShowMiniHeader) && <Footer />}
      </div>
    </NavigationGuard>
  );
}

export default App;
